export default __webpack_public_path__ + "static/media/linkedin-shared.c5cf2d1b.png";